<template>
    <CRenderFunction flat :contentToRender="menu" />
</template>

<script>
import Nav from "./_nav";
import { mapGetters } from "vuex";
import baseMixin from "~/mixins/base.js";

export default {
    mixins: [baseMixin],
    created() {
        let children = [];
        for (let i = 0; i < Nav.length; i++) {
            let element = Nav[i];
            element["name"] = this.$t(element["name"]);
            if (element["_name"] == "CSidebarNavDropdown") {
                let items = [];
                for (let i = 0; i < element["items"].length; i++) {
                    const item = element["items"][i];
                    const itemName = this.$t(item["name"]);
                    if (!item["roles"]) {
                        items.push({
                            ...item,
                            name: itemName,
                        });
                    }
                    if (
                        item["roles"] &&
                        this.isAuthorized(item["roles"], this.storeAuthUser.groups)
                    ) {
                        items.push({
                            ...item,
                            name: itemName,
                        });
                    }

                    // element["items"][i]["name"] = this.$t(item["name"]);
                }
                element["items"] = items;
            }
            if (!element["roles"]) children.push(element);
            if (
                element["roles"] &&
                this.isAuthorized(element["roles"], this.storeAuthUser.groups)
            ) {
                children.push(element);
            }
        }

        this.menu[0]._children = children;
    },

    computed: {
        ...mapGetters({
            storeAuthUser: "auth/user",
        }),
    },

    data: () => ({
        menu: [
            {
                _name: "CSidebarNav",
                _children: [],
            },
        ],
    }),
};
</script>
